var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"inline-block text-blue-600 focus:text-blue-600 hover:text-blue-600 font-medium whitespace-nowrap text-sm border rounded px-4 py-1.5 hover:border-blue-600",attrs:{"role":"button"},on:{"click":_vm.impersonate}},[_vm._v("Impersonate")])
}
var staticRenderFns = []

export { render, staticRenderFns }